<div class="maintenance-container" [@fadeIn]>

  <!-- Partie visuelle (droite sur desktop) -->
  <div class="maintenance-visual" aria-hidden="true">
    <div class="maintenance-visual__bg">
      <div class="maintenance-visual__circle maintenance-visual__circle--green"></div>
      <div class="maintenance-visual__circle maintenance-visual__circle--red"></div>
      <div class="maintenance-visual__circle maintenance-visual__circle--yellow"></div>
      <div class="maintenance-visual__gradient"></div>
    </div>
    <div class="maintenance-visual__gear-wrapper">
      <div class="maintenance-visual__gear maintenance-visual__gear--large">
        <i class="pi pi-cog"></i>
      </div>
      <div class="maintenance-visual__gear maintenance-visual__gear--small">
        <i class="pi pi-cog"></i>
      </div>
    </div>
    <p class="maintenance-visual__tagline">Nous revenons très bientôt</p>
  </div>

  <!-- Partie contenu (gauche) -->
  <div class="maintenance-content">
    <div class="maintenance-content__inner" [@slideUp]>

      <!-- Logo -->
      <div class="maintenance-logo">
        <img src="/assets/icons/Logo CIMENCAM.svg" alt="My Cimencam" width="180" height="63" loading="eager" />
      </div>

      <!-- Icône principale -->
      <div class="maintenance-icon">
        <div class="maintenance-icon__ring">
          <i class="pi pi-wrench"></i>
        </div>
      </div>

      <!-- Titre & message -->
      <div class="maintenance-message">
        <h1 class="maintenance-message__title">Application en maintenance</h1>
        <p class="maintenance-message__subtitle">
          Nous effectuons des opérations de maintenance afin d'améliorer vos services.
          L'application sera de nouveau disponible très prochainement.
        </p>
      </div>

      <!-- Bannière informative -->
      <div class="maintenance-banner" role="status">
        <i class="pi pi-info-circle maintenance-banner__icon"></i>
        <div class="maintenance-banner__text">
          <strong>Merci pour votre compréhension.</strong>
          <span>Toutes vos données sont conservées et sécurisées.</span>
        </div>
      </div>

      <!-- Séparateur -->
      <div class="maintenance-divider">
        <span>Vous êtes administrateur ?</span>
      </div>

      <!-- Bouton connexion -->
      <button type="button" class="maintenance-login-btn" (click)="goToLogin()">
        <i class="pi pi-shield"></i>
        <span>Accéder à la connexion</span>
        <i class="pi pi-arrow-right maintenance-login-btn__arrow"></i>
      </button>

    </div>
  </div>

</div>
